import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import ServicesIntro from './components/ServicesIntro';
import Automation from './components/Automation';
import Oversight from './components/Oversight';
import DesignConsult from './components/DesignConsult';
import Audience from './components/Audience';
import Problems from './components/Problems';
import Area from './components/Area';
import Reviews from './components/Reviews';
import About from './components/About';
import Partners from './components/Partners';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="min-h-screen bg-white text-[#0f1a2b] font-body antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ServicesIntro />
        <Automation />
        <Oversight />
        <DesignConsult />
        <Audience />
        <Problems />
        <Area />
        <Reviews />
        <About />
        <Partners />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
